import PropTypes from "prop-types";

import styled from "styled-components/macro";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import FnrIcon from "UI/FnrIcon";
import { FnrToggle, FnrToggleChild } from "UI/FnrToggle2";
import {
  TabBackground,
  TabBar,
  TabCustomHoverElement,
  TabCustomSelectedElement,
  TabItems,
  TabText,
  TabWrapper,
  tabToggleStyles,
} from "UI/tabBarStyles";

import GivingTab from "./GivingTab";

RecurringAndPledgesTabBar.propTypes = {
  givingTab: PropTypes.string,
  updateGivingTab: PropTypes.func,
  showPledgingTab: PropTypes.bool,
  showRecurringTab: PropTypes.bool,
};

export default function RecurringAndPledgesTabBar({
  givingTab,
  updateGivingTab,
  showPledgingTab,
  showRecurringTab,
}) {
  const {
    state: { userID },
  } = useManageMyGivingPage();

  const colors = {
    default: "#ffffff",
    hover: "#ffffff",
    selected: "#ffffff",
    disabled: "#ffffff",
  };

  return (
    <FnrToggle
      style={tabToggleStyles}
      CustomSelectedElement={TabUnderlineSelectedElement}
      CustomHoverElement={TabCustomHoverElement}
    >
      <Wrapper>
        <TabBar>
          <STabItems>
            {showRecurringTab ? (
              <GivingTab
                givingTab={givingTab}
                setGivingTab={updateGivingTab}
                givingTabKey="recurring"
                text="Recurring Gifts"
                icon="fa-repeat fad"
                colors={colors}
              />
            ) : null}
            {showPledgingTab ? (
              <GivingTab
                givingTab={givingTab}
                setGivingTab={updateGivingTab}
                givingTabKey="pledges"
                text="Pledges"
                icon="fa-handshake fad"
                colors={colors}
              />
            ) : null}
          </STabItems>
        </TabBar>
        <TabBar className="payment_methods_button_above">
          <TabItems>
            <A
              href={`/dashboard/user/${userID}#wallet`}
              target="_blank"
              rel="noreferrer"
            >
              <TabWalletWrapper>
                <FnrToggleChild style={{ flexGrow: 0 }}>
                  <TabBackground style={{ fontSize: 20 }} colors={colors}>
                    <FnrIcon fad fa-wallet />
                    <TabText>My Payment Methods</TabText>
                  </TabBackground>
                </FnrToggleChild>
              </TabWalletWrapper>
            </A>
          </TabItems>
        </TabBar>
      </Wrapper>
    </FnrToggle>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 2px;
`;

const STabItems = styled(TabItems)`
  @media (max-width: 340px) {
    padding-left: 10px;
    padding-right: 0;
  }
`;

const TabUnderlineSelectedElement = styled(TabCustomSelectedElement)`
  &::after {
    background: #fff;
  }
`;
const A = styled.a`
  text-decoration: none !important;
`;
const TabWalletWrapper = styled(TabWrapper)`
  font-weight: 400;
  & ${TabText} {
    font-size: 18px;
  }
`;
